import React, { useState } from 'react';

const AccordionContext = React.createContext();

const AccordionProvider = (props) => {

    const [activeTab, setActiveTab] = useState()

    if(props.disabled) return props.children

    return (
        <AccordionContext.Provider value={[activeTab, setActiveTab]}>
            {props.children}
        </AccordionContext.Provider>
    );
}

export { AccordionContext, AccordionProvider }